exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tracking-order-container[data-v-78e7ebde] {\n  background-color: black;\n}\n@media (max-width: 768px) {\n.tracking-order-container[data-v-78e7ebde] {\n    padding: 20px !important;\n}\n}\n.tracking-order-container .loading[data-v-78e7ebde] {\n  background-color: rgba(0, 0, 0, 0.8);\n}", ""]);

// exports
